import { lazy } from "react";

export const CertifyOtpPage = lazy(() => import("./CertifyOtpPage"));